export enum GAEventCategory {
    DigitalTicket = 'digital-ticket',
    InternalPromotions = 'Internal Promotions',
    Search = 'search',
    PWA = 'PWA',
    UX = 'UX',
    FanReport = 'add-fan-report',
    NewsletterSubscriptions = 'newsletter-subscriptions',
}
